// @flow
import * as React from 'react';
import DeliveryStatus from 'constants/DeliveryStatus';

type Props = {
  status: string,
};

class DeliveryStatusLabel extends React.Component<Props, void> {
  render() {
    switch (this.props.status) {
      case DeliveryStatus.SENDING:
        return 'Sending';
      case DeliveryStatus.DELIVERY_ERROR:
        return 'Error';
      case DeliveryStatus.READ:
        return 'Read';
      case DeliveryStatus.SENT:
        return 'Sent';
      case DeliveryStatus.DELIVERED:
        return 'Delivered';
      default:
        return null;
    }
  }
}

export default DeliveryStatusLabel;
